import * as Sentry from "@sentry/vue";
import type { App } from "vue";

export default {
  install: (app: App) => {
    console.info("Initializing Sentry error logging");

    if (!import.meta.env.VITE_SENTRY_DSN) {
      console.warn("Sentry error logging disabled, missing DSN");
      return;
    }

    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,

      // The widget is embedded in third-party websites, so only report errors
      // originating from our own scripts instead of the host page's
      allowUrls: [import.meta.env.VITE_FRONTEND_URL],

      integrations: [
        // Registers and configures the Tracing integration, which automatically instruments your
        // application to monitor its performance, including custom Angular routing instrumentation.
        // Sentry.browserTracingIntegration(),
        // Registers the Replay integration, which automatically captures Session Replays.
        // Sentry.replayIntegration(),
      ],

      // Set tracesSampleRate to 1.0 to capture 100% of transactions for tracing. We recommend
      // adjusting this value in production. Learn more at
      // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
      tracesSampleRate: 1.0,

      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

      // Set replaysSessionSampleRate to 0.1 to capture Capture Replay for 10% of all sessions,
      // plus set replaysOnErrorSampleRate to 1.0 for 100% of sessions with an error. Learn more at
      // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  },
};
